import { db } from '@smart-maps/firebase';

import { APP_MAP_ID, EVENT_TYPES } from '../../constants';

export const updateLastCenter = latlng => ({
  payload: latlng,
  type: EVENT_TYPES.LASTCENTER_UPDATE,
});

export const updateLastActivity = () => ({
  payload: Date.now(),
  type: EVENT_TYPES.LASTCENTER_UPDATE,
});

export const logoutUser = () => ({
  type: EVENT_TYPES.USER_LOGOUT,
});

export const deleteUser = uid => async dispatch => {
  await db.remove(uid, `${APP_MAP_ID}/done`);
  dispatch({
    type: EVENT_TYPES.USER_LOGOUT,
  });
};

export const toggleNavigation = id => ({
  payload: id,
  type: EVENT_TYPES.NAVIGATION_TOGGLE,
});
